import React, { useState } from 'react';
import { Phone, Check } from 'lucide-react';
import { supabase } from '../supabaseClient';
import { useAuth } from '../context/AuthContext';

const SupportPage = () => {
  const { user } = useAuth();
  const [phone, setPhone] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const { error: insertError } = await supabase
        .from('support_requests')
        .insert([{
          user_id: user.id,
          phone: phone
        }]);

      if (insertError) throw insertError;

      setSubmitted(true);
      setTimeout(() => {
        setSubmitted(false);
        setPhone('');
      }, 3000);
    } catch (err) {
      console.error('Error submitting support request:', err);
      setError('Erro ao enviar pedido. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto">
      <h1 className="text-3xl font-bold text-gray-900 mb-8">Suporte</h1>

      <div className="bg-white rounded-xl shadow-md p-8 border border-primary/10">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-12 bg-secondary/10 rounded-full flex items-center justify-center">
            <Phone className="w-6 h-6 text-secondary" />
          </div>
          <div>
            <h2 className="text-xl font-semibold text-gray-900">Precisa de ajuda?</h2>
            <p className="text-sm text-gray-600">Submeta um pedido de suporte abaixo e entraremos em contacto em breve</p>
          </div>
        </div>

        {error && (
          <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
            <p className="text-sm text-red-800">{error}</p>
          </div>
        )}

        {submitted ? (
          <div className="bg-green-50 border border-green-200 rounded-lg p-6 flex items-center gap-3">
            <Check className="w-6 h-6 text-green-600" />
            <div>
              <p className="font-medium text-green-900">Pedido de contacto enviado!</p>
              <p className="text-sm text-green-700">Entraremos em contacto brevemente.</p>
            </div>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Número de Telefone
              </label>
              <input
                type="tel"
                required
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                placeholder="912 345 678"
                disabled={loading}
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full py-3 bg-gradient-primary text-white font-semibold rounded-lg hover:shadow-lg hover:-translate-y-0.5 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? 'A enviar...' : 'Pedir Contacto'}
            </button>
          </form>
        )}

        <div className="mt-8 pt-6 border-t border-gray-200">
          <h3 className="font-semibold text-gray-900 mb-4">Outros contactos</h3>
          <div className="space-y-2 text-sm text-gray-600">
            <p>Email: tomas@omaza.ai</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupportPage;